/**
 * Organisation query keys. There is one organisation per token, so `me()` is
 * the only read; the onboarding writes invalidate it.
 */
export const OrganizationQueryKeys = {
    all: ['organizations'] as const,
    me: () => [...OrganizationQueryKeys.all, 'me'] as const,
};
